<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md6>
        <v-card class="elevation-6" color="blue-grey darken-4" dark>
          <v-card-title>
            <span
              class="title font-weight-light text-center"
              style="text-transform: uppercase"
            >Bienvenido al Formulario en línea de presentación de observaciones a las Versiones Voluntarias por las víctimas acreditadas en al marco del Caso No. 01</span>
          </v-card-title>

          <v-divider class="mx-1"></v-divider>

          <v-card-text class="headline title font-weight-light text-center">
            <v-card class="elevation-12" color="lime darken-2" dark>
              <v-card-title>
                <v-icon large left>mdi-twitter</v-icon>
                <span class="title font-weight-light"></span>
              </v-card-title>

              <v-card-text class="headline font-weight-bold text-center">
                VÍCTIMAS
                <v-spacer></v-spacer>
                <v-btn
                  color="lime darken-4"
                  text
                  @click="irFormularioAcceso('personas')"
                  class="ma-2"
                  outlined
                >Ir al formulario de acceso</v-btn>
              </v-card-text>

              <v-card-actions></v-card-actions>
            </v-card>

            <v-divider class="mx-1"></v-divider>

            <v-card class="elevation-12" color="lime darken-2" dark>
              <v-card-title>
                <v-icon large left>mdi-twitter</v-icon>
                <span class="title font-weight-light"></span>
              </v-card-title>

              <v-card-text class="headline font-weight-bold text-center">
                REPRESENTANTES
                <v-spacer></v-spacer>
                <v-btn
                  color="lime darken-4"
                  text
                  @click="irFormularioAcceso('representantes')"
                  class="ma-2"
                  outlined
                >Ir al formulario de acceso</v-btn>
              </v-card-text>

              <v-card-actions></v-card-actions>
            </v-card>
          </v-card-text>

          <v-card-actions></v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import router from "../../router/index.js";

export default {
  data: () => ({}),
  created() {
    this.initialize();
  },
  mounted() {},
  components: {},
  computed: {},
  watch: {},
  methods: {
    initialize() {},
    irFormularioAcceso(formulario) {
      window.location.replace(`/traslado/${formulario}`);
    }
  }
};
</script>
<style lang="css" scoped>
.estilo_dos_columnas {
  width: 50%;
  margin-left: 5px;
  margin-top: 5px;
}
.estilo_tres_columnas {
  width: 33%;
  padding-right: 10px;
  padding-top: 15px;
}
</style>
